"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Icon = require("../js/Icon");

var _Icon2 = _interopRequireDefault(_Icon);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WrappedIcon = function WrappedIcon(props) {
  return _react2.default.createElement(
    _Icon2.default,
    props,
    _react2.default.createElement(
      "svg",
      { className: "spectrum-UIIcon-CrossLarge" },
      _react2.default.createElement("path", { d: "M11.7 10.283L7.414 6 11.7 1.717A1 1 0 1 0 10.283.3L6 4.586 1.717.3A1 1 0 1 0 .3 1.717L4.586 6 .3 10.283A1 1 0 1 0 1.717 11.7L6 7.414l4.283 4.286a1 1 0 1 0 1.417-1.417z", className: "spectrum-UIIcon--medium" }),
      _react2.default.createElement("path", { d: "M15.7 14.283L9.414 8 15.7 1.717A1 1 0 1 0 14.283.3L8 6.586 1.717.3A1 1 0 1 0 .3 1.717L6.586 8 .3 14.283A1 1 0 1 0 1.717 15.7L8 9.414l6.283 6.286a1 1 0 1 0 1.417-1.417z", className: "spectrum-UIIcon--large" })
    )
  );
};

WrappedIcon.displayName = 'CrossLarge';
exports.default = WrappedIcon;

